import type { CourseFeeItem, FeeCountry } from '~/data/courseFees'

const perferedCountryOrder: FeeCountry[] = [
  'Malaysia',
  'Singapore',
  'Hong Kong',
  'Taiwan',
  'Thailand',
  'Indonesia',
  'Philippines',
  'Global'
]

export function getCountriesFromPrices(prices: CourseFeeItem['prices']) {
  // Get the country from the prices array
  // Sort the countries based on the preferred order
  return prices
    .map((price) => price.country)
    .sort((a, b) => {
      return perferedCountryOrder.indexOf(a) - perferedCountryOrder.indexOf(b)
    })
}
